import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=b859131e&"
import script from "./Resources.vue?vue&type=script&lang=js&"
export * from "./Resources.vue?vue&type=script&lang=js&"
import style0 from "./Resources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports